const mapParcelOrder = order => ({
  id: order.id,
  name: order.name,
  email: order.email,
  external_url: order.external_url,
  order_tracking_page_url: order.order_tracking_page_url,
  created_at: order.created_at,
  is_exchange: order.is_exchange,
})

const mapParcelCarrier = carrier => {
  if (!carrier) return null

  return {
    id: carrier.id,
    name: carrier.name,
    logo_url: carrier.logo_url,
  }
}

const mapParcelMethod = method => {
  if (!method) return null

  return {
    id: method.id,
    name: method.name,
    carrier: method.carrier,
    carrier_email: method.carrier_email,
  }
}

const mapParcelRelatedShipping = shipping => ({
  return_labels: shipping.return_labels,
})

const mapParcelRelated = related => {
  if (!related) return null

  return {
    id: related.id,
    sender_location: related.sender_location,
    sender_address: related.sender_address,
    recipient_address: related.recipient_address,
    service_point_address: related.service_point_address,
    customer_address: related.customer_address,
    reference_number: related.reference_number,
    shipping_method: related.shipping_method,
    with_customs: related.with_customs,
    requires_customer_tax_id: related.requires_customer_tax_id,
    notes: related.notes,
    customer_notes: related.customer_notes,
    alert_type: related.alert_type,
    has_alerts: related.has_alerts,
    sequence_number: related.sequence_number,
    shipments_in_order: related.shipments_in_order,
    returns_in_order: related.returns_in_order,
    is_exchange: related.is_exchange,
    line_items: related.line_items,
    labels: related.labels,
    shipping: related.shipping ? mapParcelRelatedShipping(related.shipping) : related.shipping,
    order: related.order,
    eta: related.eta,
    currency: related.currency,
    total: related.total,
    base: related.base,
    duties: related.duties,
    tax: related.tax,
    currency_adjustment: related.currency_adjustment,
    handling_fees: related.handling_fees,
    additional_products: related.additional_products,
  }
}

const mapParcel = parcel => ({
  related: mapParcelRelated(parcel.related),
  id: parcel.id,
  type: parcel.type,
  status: parcel.status,
  created_at: parcel.created_at,
  modified_at: parcel.modified_at,
  order: mapParcelOrder(parcel.order),
  carrier: mapParcelCarrier(parcel.carrier),
  customer_profile: parcel.customer_profile,
  method: mapParcelMethod(parcel.method),
  items_quantity: parcel.items_quantity,
  origin: parcel.origin,
  destination: parcel.destination,
  tracking_number: parcel.tracking_number,
  tracking_url: parcel.tracking_url,
  pickup_scheduled: parcel.pickup_scheduled,
  normalized_tracking_status: parcel.normalized_tracking_status,
  tracking_status: parcel.tracking_status,
  registered_at: parcel.registered_at,
  etas: parcel.etas,
  rating: parcel.rating,
  packed_at: parcel.packed_at,
  ready_at: parcel.ready_at,
  shipped_at: parcel.shipped_at,
  out_for_delivery_at: parcel.out_for_delivery_at,
  delivered_at: parcel.delivered_at,
  cancelled_at: parcel.cancelled_at,
})

export const transformResponseParcels = response => ({
  next: response.next,
  previous: response.previous,
  results: response.results.map(mapParcel),
})

const mapParcelAlert = alert => {
  if (!alert) return null

  return {
    id: alert.id,
    type: alert.type,
    created_at: alert.created_at,
    properties: alert.properties,
  }
}

const mapParcelTimelineEvent = event => ({
  id: event.id,
  created: event.created,
  type: event.type,
  source: event.source,
  properties: event.properties,
  user: event.user,
  images: event.images,
  alert_type: event.alert_type,
  alert_properties: event.alert_properties,
  read_at: event.read_at,
})

const mapParcelDocumentLabel = label => ({
  label_url: label.label_url,
  zpl_label_url: label.zpl_label_url,
  qr_label_url: label.qr_label_url,
  customs_declaration_url: label.customs_declaration_url,
  created_at: label.created_at,
})

const mapParcelDocuments = documents => {
  if (!documents) return { invoice_url: null, labels: [] }

  return {
    invoice_url: documents.invoice_url,
    labels: documents.labels.map(mapParcelDocumentLabel),
  }
}

const mapParcelClaim = claim => ({
  id: claim.id,
  type: claim.type,
  status: claim.status,
  message: claim.message,
  opened_at: claim.opened_at,
})

const mapParcelClaims = claims => {
  if (!claims) return []

  return claims.map(mapParcelClaim)
}

const mapParcelCustomerTaxCode = customerTaxCode => {
  return {
    type: customerTaxCode.type,
    country_code: customerTaxCode.country_code,
    value: customerTaxCode.value,
    title: customerTaxCode.title,
  }
}

const mapParcelCustomerTaxCodes = customerTaxCodes => {
  if (!customerTaxCodes) return []

  return customerTaxCodes.map(mapParcelCustomerTaxCode)
}

export const transformResponseParcelDetail = parcel => ({
  ...mapParcel(parcel),
  order: {
    ...mapParcelOrder(parcel.order),
    customer_tax_numbers: mapParcelCustomerTaxCodes(parcel.order.customer_tax_numbers),
  },
  documents: mapParcelDocuments(parcel.documents),
  items: parcel.items,
  alert: mapParcelAlert(parcel.alert),
  claims: mapParcelClaims(parcel.claims),
  timeline_events: parcel.timeline_events.map(mapParcelTimelineEvent),
})
